import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

type Me2onBundleProps = {
  backgroundSrc: any;
  backgroundColor: any;
  quantityDisplay: any;
  productColor: any;
  bundleButtonColor: any;
  isThreeProducts: boolean;
};

export const StyledMe2onBundle = styled.div<Me2onBundleProps>`
  box-sizing: border-box;
  border-radius: 15px;
  background: var(--bundle-border-color);
  font-family: var(--font-family), Arial;
  width: 100%;
  height: 200px;
  padding: 4px;
  position: relative;

  .container {
    background: ${({ backgroundSrc, backgroundColor }: any) =>
      backgroundSrc
        ? `url("${backgroundSrc}")`
        : createGradientOrSolid(backgroundColor)};
    width: 100%;
    height: 100%;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .badge {
    &-emblem {
      position: absolute;
      width: 64px;
      height: 64px;
      left: -12px;
      top: -8px;

      &--image {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .amount {
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    z-index: 1;

    &-main {
      margin: 8px auto 0;
      background: rgba(0, 0, 0, 0.4);
      padding: 4px 8px;
      border-radius: 20px;

      .price {
        font-size: 1.25rem;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 164, 1),
          rgba(255, 178, 54, 1)
        );
        background-clip: text;
        -webkit-background-clip: text;
        -moz-background-clip: text;
        -webkit-text-fill-color: transparent;
        position: relative;

        &::after {
          background: none;
          content: '${({ quantityDisplay }) => quantityDisplay}';
          left: 0;
          top: 0;
          z-index: -1;
          position: absolute;
          text-shadow: 0 2px 0 #bf3f00;
        }
      }
    }

    &-stroked {
      color: #ffefb8;
      font-size: 1rem;
      margin: auto;
      text-decoration-color: #d8232a;
      position: relative;
      text-shadow: 0 2px rgba(0, 0, 0, 0.8);

      &::after {
        content: ' ';
        height: 1px;
        width: 100%;
        background: #d8232a;
        position: absolute;
        left: 0;
        top: 50%;
      }
    }
  }

  .products {
    margin-left: 8px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    &-sub {
      box-sizing: border-box;
      border-radius: 12px;
      width: 100%;
      max-width: 145px;
      height: 113px;
      background: rgba(1, 1, 1, 10%);
      padding: 8px 4px;
      display: flex;
      justify-content: ${({ isThreeProducts }: any) =>
        isThreeProducts ? 'space-between' : 'center'};
      flex-direction: column;
      overflow: auto;
      z-index: 1;
      scrollbar-width: thin;
      scrollbar-color: rgb(90, 90, 90) transparent;

      &--ios13 {
        display: ${({ isThreeProducts }: any) =>
          isThreeProducts ? 'block' : 'flex'};
      }

      .product {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }

        &-image {
          position: absolute;
          width: 32px;
          height: 32px;

          .image {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        &-amount {
          background: rgba(0, 0, 0, 0.2);
          border-radius: 30px;
          padding: 4px 4px 4px 0;
          margin-left: 15px;
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          width: 100%;
          text-align: center;
          color: ${({ productColor }: any) => productColor};
          text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
            1px 1px 0 #000, 0 2px 1px #000;
        }
      }
    }

    &-main {
      width: 180px;
      height: 180px;
      position: absolute;
      right: 0;
      margin-right: 4px;
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
      top: 50%;
      transform: translatey(-50%);

      &-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        position: absolute;
        border-bottom-right-radius: 8px;
        border-top-right-radius: 8px;
      }

      .price {
        margin: 0 auto 6px;
        padding: 6px;
        height: auto;
        border-radius: 30px;
        width: 140px;
        background: ${({ bundleButtonColor }: any) =>
          bundleButtonColor &&
          createGradientOrSolid(
            bundleButtonColor,
            !!bundleButtonColor.colorTwo,
          )};
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.8);
        overflow: hidden;

        .white_stripe {
          border-top-left-radius: 30px;
          border-top-right-radius: 30px;
        }

        .totalPrice {
          font-size: 1.25rem;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-transform: capitalize;
        }
      }
    }
  }
`;
